module.exports = {
      id: "back-icon-usage",
      viewBox: "0 0 7.828 12.828",
      url: "/" + "sprite-a402f8ffc4310bc2e096ed6c94b22ccb.svg#back-icon",
      toString: function () {
        return this.url;
      }
    }